import { HHTextField } from '@hinge-health/react-component-library';
import Autocomplete from '@mui/material/Autocomplete';
import { Controller } from 'react-hook-form';
import { PartnershipFilterProps, StatusFilterLabelText } from './filter-types';

export const PartnershipFilter = ({
  control,
  name = 'partnerships',
  partnerships,
  hasError = false,
  variant = 'standard',
  sx = { minWidth: 230, maxWidth: 230 },
  label = StatusFilterLabelText.PARTNERSHIP,
  loading = false,
}: PartnershipFilterProps): JSX.Element => (
  <Controller
    control={control}
    name={name}
    render={({ field: { onChange, value } }): JSX.Element => (
      <Autocomplete
        multiple
        id="partnerships-select"
        options={!hasError ? partnerships : []}
        disabled={!!hasError || loading}
        getOptionLabel={(option): string => option.name}
        isOptionEqualToValue={(option, value): boolean =>
          option.id === value.id
        }
        size="small"
        limitTags={1}
        sx={sx}
        blurOnSelect={true}
        onChange={(_, newValue): void => onChange(newValue)}
        value={value}
        renderInput={(params): JSX.Element => (
          <HHTextField
            {...params}
            hhVariant="variant-bypass"
            variant={variant}
            label={label}
            error={!!hasError}
            helperText={hasError ? 'partnerships unavailable' : ''}
          />
        )}
      />
    )}
  />
);
